import { defineComponent as _defineComponent } from 'vue'
import store from '@/store'
import TicketLeft from '@/features/tickets/assets/TicketLeft.vue'
import AvatarPlaceholder from '@/features/tickets/assets/AvatarPlaceholder.vue'
import { useImage } from '@/shared/composables/image'
import { ModalWrapper } from '@/shared/ui/modals'
import { computed, ref } from 'vue'
import MyTicketsInterface from '@/features/tickets/ui/MyTicketsInterface.vue'
import { useEventQuery } from '@/enitites/event/api/queries'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventPurchasedTickets',
  props: {
    eventId: null
  },
  setup(__props: any) {

const props = __props as {
  eventId: number
};

// @ts-expect-error Not a ts file


const getUserDB = computed(() => store.getters.getUserDB)
const { getImageById } = useImage()
const { data: event } = useEventQuery(props.eventId)

const tickets = computed(() => event.value?.paymentSystem?.tickets)
const isHost = computed(
  () => event.value?.permissions.canEdit || event.value?.staff.hosts?.some(({ id }) => id === getUserDB.value?.id)
)

const isShowModal = ref(false)
const selectedTicketId = ref<number>()

const handleOpenModal = (ticketId: number) => {
  selectedTicketId.value = ticketId
  isShowModal.value = true
}

return { __sfc: true,props, getUserDB, getImageById, event, tickets, isHost, isShowModal, selectedTicketId, handleOpenModal, TicketLeft, AvatarPlaceholder, ModalWrapper, MyTicketsInterface }
}

})